import React, { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Modal from '../Modal';
import { FormEditor } from '../Editor';
import TextInputWithButton from '../../Components/TextInputWithButton';
import useProductName from '../../Hooks/useProductName';
import { productId } from '../../Constants/producs';

import commonActions from '../../Actions/commonActions';
import customerActions from '../../Actions/customerActions';

const VismaVceModal = ({ onClose }) => {
    const dispatch = useDispatch();

    const customer = useSelector(state => state.CustomerReducer.customer);
    const vbCustomer = customer?.vbCustomer;
    const vceEmailTemplate = useSelector(state => state.CommonReducer.forms?.vceEmailTemplate);

    const { translatedProductName } = useProductName();
    const productName = translatedProductName(productId.companyexpense);

    useEffect(() => {
        if (vbCustomer) {
            dispatch(customerActions.getVceEmailTemplate(vbCustomer.organizationNumber, vbCustomer.name));
        }
    }, [vbCustomer, dispatch]);

    const handleFieldChange = useCallback((field, value) => {
        dispatch(commonActions.changeMultiFormField('vceEmailTemplate', field, value));
    }, [dispatch]);

    const handleClickSave = () => {
        if (vceEmailTemplate && vbCustomer) {
            dispatch(customerActions.activateVce(
                vceEmailTemplate,
                vbCustomer.customerNumber,
                handleClickClose
            ));
        }
    };

    const handleClickClose = () => {
        dispatch(commonActions.cancelFormEditing('vceEmailTemplate', onClose));
    };

    if (!vceEmailTemplate) return null;

    const emailInputProps = {
        buttonTitle: 'Use contact email',
        buttonClick: () => handleFieldChange('to', vbCustomer.contactPerson.email),
        label: 'Email *',
        value: vceEmailTemplate.data.to,
        onChange: value => handleFieldChange("to", value),
    };

    const modalProps = {
        title: productName,
        mainButtonTitle: 'Activate',
        onCancelClick: handleClickClose,
        stateful: true,
        open: true,
        onChange: handleFieldChange,
        onSaveClick: handleClickSave
    };

    return (
        <Modal {...modalProps}>
            <form className="form-horizontal">
                <fieldset>
                    <TextInputWithButton {...emailInputProps} />
                    <FormEditor
                        label="Description *"
                        toolbar={false}
                        value={vceEmailTemplate.data.body}
                        onChange={value => handleFieldChange("body", value)}
                    />
                </fieldset>
            </form>
        </Modal>
    );
};

export default VismaVceModal;